import { useNavigate } from "react-router-dom";
import { useVerifyRol } from "./useVerifyRols";
import { AuthStateProps } from "../models/auth";
import { useAppSelector } from "./ReduxHooks";
import { shallowEqual } from "react-redux";
export const usePanelItems = () => {
  const navigate = useNavigate();
  const { verifyRol } = useVerifyRol();
  const { owner } = useAppSelector(
    (state: { auth: AuthStateProps }) => state.auth,
    shallowEqual
  );

  const items = [
    {
      label: "Institución",
      icon: "pi pi-home",
      command: () => navigate("/panel/institution"),
      path: "/panel/institution",
    },
    ...(owner
      ? [
          {
            label: "Estadísticas",
            icon: "pi pi-chart-bar",
            command: () => navigate("/panel/dashboard"),
            path: "/panel/dashboard",
          },
        ]
      : []),
    {
      label: "Cuotas",
      icon: "pi pi-credit-card",
      command: () => navigate("/panel/quota"),
      path: "/panel/quota",
    },
    {
      label: "Usuarios",
      icon: "pi pi-users",
      command: () => navigate("/panel/users"),
      path: "/panel/users",
    },
    {
      label: "Deportes",
      icon: "pi pi-discord",
      command: () => navigate("/panel/sports"),
      path: "/panel/sports",
    },

    ...(owner
      ? [
          {
            label: "Administradores",
            icon: "pi pi-lock-open",
            command: () => navigate("/panel/admins"),
            path: "/panel/admins",
          },
          {
            label: "Plan",
            icon: "pi pi-star",
            command: () => navigate("/panel/plan"),
            path: "/panel/plan",
          },
          {
            label: "Pagos",
            icon: "pi pi-dollar",
            command: () => navigate("/panel/payments"),
            path: "/panel/payments",
          },
        ]
      : []),

    ...(verifyRol({ A: true })
      ? [
          {
            label: "Usuarios",
            icon: "pi pi-user",
            items: [
              {
                label: "Ver usuarios",
                icon: "pi pi-users",
                command: () => navigate("/panel/admin/users"),
                path: "/panel/admin/users",
              },
              {
                label: "Nuevo usuario",
                icon: "pi pi-user-plus",
                command: () => navigate("/panel/admin/users/new"),
                path: "/panel/admin/users/new",
              },
            ],
          },
        ]
      : []),
    ...(verifyRol({ SA: true, A: true })
      ? [
          {
            label: "Instituciones",
            icon: "pi pi-th-large",
            items: [
              {
                label: "Ver instituciones",
                icon: "pi pi-list",
                command: () => navigate("/panel/admin/institutions"),
                path: "/panel/admin/institutions",
              },
              {
                label: "Nueva institución",
                icon: "pi pi-plus",
                command: () => navigate("/panel/admin/institutions/new"),
                path: "/panel/admin/institutions/new",
              },
              {
                label: "Adm deportes",
                icon: "pi pi-file-edit",
                command: () => navigate("/panel/admin/manage-sports"),
                path: "/panel/admin/manage-sports",
              },
            ],
          },
          {
            label: "Pagos",
            icon: "pi pi-wallet",
            items: [
              {
                label: "Ver cuotas",
                icon: "pi pi-credit-card",
                command: () => navigate("/panel/admin/payments"),
                path: "/panel/admin/payments",
              },
              ...(verifyRol({ SA: true })
                ? [
                    {
                      label: "Ver planes",
                      icon: "pi pi-folder-open",
                      command: () => navigate("/panel/admin/plans"),
                      path: "/panel/admin/plans",
                    },
                    {
                      label: "Nuevo plan",
                      icon: "pi pi-folder-plus",
                      command: () => navigate("/panel/admin/plans/new"),
                      path: "/panel/admin/plans/new",
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
  ];

  return items;
};
